import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import guidance from '@/views/login/guidance'
import skipDetails from '@/views/login/skipDetails'
import question from '@/views/login/question'
import video from '@/views/login/video'
import handbook from '@/views/login/handbook'
import noticeList from '@/views/login/notice/noticeList'
import confirm from '@/views/constructionUnit/task/confirm'
import noticeListat from '@/views/login/notice/noticeListat'
import ddloginskips from '@/views/login/ddloginskips'//苏州单点登录界面
import supervise_logindd from '@/views/login/xuzhou/supervise_login-dd'

//建设单位
import constructionRegister from '@/views/constructionUnit/user/register'
import designRegister from '@/views/designUnit/user/register'
import designRegister2 from '@/views/designUnit/user/register2'
import constructionforgetpassword from '@/views/constructionUnit/user/forgetpassword'
import drawforgetpassword from '@/views/constructionUnit/user/drawforgetpassword'


//多图联审
import expertReport from  '@/views/inspectDraw/business/expert/report'
import previewPDF from '@/views/common/preview/previewPDF'
import drawingPreview from '@/views/inspectDraw/business/reportExamine/drawing'
//建设单位
import censor from './censor/index'
//设计单位
import design from './design/index'
//页面对接
import loginDocking from '@/views/login/loginDocking'//苏州界面对接


//审图中心
import draw from './draw/index'
import supervise from './supervise/index'
import drawing_loginXZ from '@/views/login/xuzhou/drawing_login-xz'
import supervise_loginXZ from '@/views/login/xuzhou/supervise_login-xz'
import censor_loginXZ from '@/views/login/xuzhou/censor_login-xz'
import Indexxz from '@/views/login/xuzhou/index-xz'    //徐州
import IndexxzJump from '@/views/login/xuzhou/index-xz-jump'    //徐州
import pdfIndex from '@/views/login/pdfIndex.vue'
import pdfIndexDesign from '@/views/login/pdfIndexDesign.vue'
import pdfIndexReply from '@/views/login/pdfIndexReply'
import pdfIndexReexamine from '@/views/login/pdfIndexReexamine'
import pdfIndexAssist from '@/views/login/pdfIndexAssist'
export default new Router({
  routes: [
    censor,
    design,
    draw,
    supervise,
    {
      path: '/',
      name: 'Index',
      component: Indexxz,               //-------------------------文件替换
      meta: {name : '首页'},
      hidden: true,
    },
    {
      path: '/autoLogin',
      name: 'Index1',
      component: IndexxzJump,               //-------------------------文件替换
      meta: {name : '首页跳转'},
      hidden: true,
    },
    {
      path: '/skipDetails',
      name: 'skipDetails',
      component: skipDetails,               //-------------------------文件替换
      meta: {name : '工改对接'},
      hidden: true,
    },
    {
      path: '/censor_login-suz',
      name: 'censor_login-xz',
      component: censor_loginXZ,
      meta: {name: '建设单位登录'},
      hidden: true,
    },
    {
      path: '/drawing_login-suz',
      name: 'drawing_login-xz',
      component: drawing_loginXZ,
      meta: {name : '审图机构'},
      hidden: true,
    },
    {
      path: '/supersive_login-suz',
      name: 'supersive_login-xz',
      component: supervise_loginXZ,
      meta: {name : '监管机构'},
      hidden: true,
    },
    {
      path: '/guidance',
      name: 'guidance',
      component: guidance,
      meta: {name : '办事指南'},
      hidden: true,
    },
    {
      path: '/question',
      name: 'question',
      component: question,
      meta: {name : '常见问题'},
      hidden: true,
    },
    {
      path: '/video',
      name: 'video',
      component: video,
      meta: {name : '参考视频'},
      hidden: true,
    },
    {
      path: '/handbook',
      name: 'handbook',
      component: handbook,
      meta: {name : '操作手册'},
      hidden: true,
    },
    {
      path: '/noticeList',
      name: 'noticeList',
      component: noticeList,
      meta: {name : '信息公开'},
      hidden: true,
    },
    {
      path: '/noticeListat',
      name: 'noticeListat',
      component: noticeListat,
      meta: {name : '公告详情'},
      hidden: true,
    },
    {
      path: '/confirm',
      name: 'confirm',
      component: confirm,
      meta: {name : '表单确认'},
      hidden: true,
    },
    {
      path: '/constructionUnit/register',
      component: constructionRegister,
      name: 'constructionRegister',
    },{
      path: '/design/register',
      component: designRegister,
      name: 'designRegister',
    },{
      path: '/design/register2',
      component: designRegister2,
      name: 'designRegister2',
    },
    {
      path: '/common/previewPDF',
      component: previewPDF,
      name: 'previewPDF',
    },{
      path: '/drawingPreview',
      component: drawingPreview,
      name: 'drawingPreview',
    },{
			path: '/expertReport',
	    component: expertReport,
      name: 'expertReport',
    },
    {
      path: '/login/loginDocking',//CA登录
      component: loginDocking,
      name: 'loginDocking',
    },
    {
      path: '/login/pdfIndex',//
      component: pdfIndex,
      name: 'pdfIndex',
    },
    {
      path: '/login/pdfIndexAssist',//
      component: pdfIndexAssist,
      name: 'pdfIndexAssist',
    },
    
    {
      path: '/login/pdfIndexDesign',//
      component: pdfIndexDesign,
      name: 'pdfIndexDesign',
    },
    {
      path: '/login/pdfIndexReply',//
      component: pdfIndexReply,
      name: 'pdfIndexReply',
    },
    {
      path: '/login/pdfIndexReexamine',//
      component: pdfIndexReexamine,
      name: 'pdfIndexReexamine',
    },
    // 建设、勘察、设计单位忘记密码
    {
      path: '/constructionUnit/forgetpassword',
      component: constructionforgetpassword,
      name: 'constructionforgetpassword',
    },
    // 审图单位忘记密码
    {
      path: '/constructionUnit/drawforgetpassword',
      component: drawforgetpassword,
      name: 'drawforgetpassword',
    },
    {
      path: '/ddloginskips',//单点登录
      name: 'ddloginskips',
      component: ddloginskips,
      meta: {name : '单点登录'},
      hidden: true,
    },
    {
      path: '/supersive_login-dd',
      name: 'supersive_login-dd',
      component: supervise_logindd,
      meta: {name : '单点登录监管机构'},
      hidden: true,
    },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js